<template>
    <div style="max-height: 500px; overflow-y: auto">
        <div v-if="isLoading">{{ $t('components.loading') }}</div>
        <div v-if="!isLoading">
            <div v-if="posts.length">
                <div v-for="post in posts" :key="post.id">
                    <FeedPost :post="post" />
                    <hr />
                </div>
            </div>
            <b-alert show variant="info" v-else>{{ $t('targets.informations.noFeedToDisplay') }}</b-alert>
        </div>
    </div>
</template>

<script>
import FeedPost from '@/views/feed/Post'
import { getActionPlanFeed } from './api'

export default {
    name: 'Feed',
    props: ['actionPlanId'],
    components: {
        FeedPost,
    },
    data() {
        return {
            posts: [],
            isLoading: false,
        }
    },
    async mounted() {
        this.isLoading = true
        const resp = await getActionPlanFeed(this.actionPlanId)
        this.posts = resp.data
        this.isLoading = false
    },
}
</script>
